
import React, { useState, useEffect } from "react";
import "../Styles/Frontpage.css";
import templeImage from "../Assests/bhad2-removebg-preview.png";

function Frontpage() {
    const [language, setLanguage] = useState("en");

    useEffect(() => {
        const updateLanguage = () => {
            const selected =
                document.querySelector(".goog-te-combo")?.value;

            const pageLanguage =
                document.documentElement.lang?.toLowerCase() || "";

            if (selected === "ta" || pageLanguage.startsWith("ta")) {
                setLanguage("ta");
            } else if (
                selected === "ml" ||
                pageLanguage.startsWith("ml")
            ) {
                setLanguage("ml");
            } else {
                setLanguage("en");
            }
        };

        document.addEventListener("change", updateLanguage);

        const observer = new MutationObserver(updateLanguage);

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["lang"],
        });

        updateLanguage();

        return () => {
            document.removeEventListener("change", updateLanguage);
            observer.disconnect();
        };
    }, []);

    const content = {
        en: {
            title: "Puliyampilly Nambooriyachan",

            history:
                "The history of this deity is inseparable from Puliyampilly Nambooriyachan (or Puliyampilly Namboori), a legendary sage, scholar, Saktheya Upasakan and Tantric practitioner whose life and miracles are famously chronicled in Kottarathil Sankunni's Aithihyamala (The Garland of Legends), a classic compendium of Kerala folklore.",

            temple:
                "This temple is an ancient and revered shrine located in North Paravoor, Ernakulam District, Kerala. The temple stands uniquely at the center of a four-way road junction, where vehicles pass around it from all directions throughout the day. Beneath the shelter of a majestic banyan tree, the sacred Prathishta and the roots of the banyan tree are grounded in the earth without a raised platform or pedestal. The shrine is surrounded by a simple, four-foot-high circular enclosure. Despite its modest appearance and its location amidst busy traffic, the temple radiates an extraordinary divine presence (Chaithanyam). It is believed that Puliyampilly Namboothiri's spiritual presence resides in this banyan tree. For generations, devotees have visited this sacred place with unwavering faith, believing that Goddess Bhadrakali listens to their prayers and showers them with protection, strength, and blessings.",

            upasanaTitle: "The Intense Upasana (Devotion)",

            upasana:
                "Puliyampilly Namboothiri was an ardent devotee of Goddess Bhadrakali. He practiced severe penance (Tapacharya) and intense spiritual disciplines to invoke the fierce form of Adi Shakti, Goddess Bhadrakali. It is said that he possessed the power to drive away evil forces through his mantra power. Traditional stories describe his worship of Goddess Bhadrakali as so intense and powerful that no evil forces could withstand his spiritual power.",

            miracleTitle: "The Miracle of the Two Moons",

            miracle:
                "One of the most famous traditional stories associated with Puliyampilly Namboothiri tells of a local king who doubted his spiritual powers. On a dark Karkidaka Amavasi (new moon night), through his extraordinary spiritual power and the grace of Goddess Bhadrakali, he is said to have made two glowing full moons appear simultaneously in the midnight sky. The king and the people who witnessed this extraordinary sight were filled with wonder and amazement. This event remains a celebrated traditional story illustrating Puliyampilly Namboothiri's spiritual power and the grace of Goddess Bhadrakali.",
        },

        ta: {
            title: "புளியம்பிள்ளி நம்பூதிரியச்சன்",

            history:
                "புளியம்பிள்ளி நம்பூதிரி, ஸ்ரீ பத்ரகாளி அம்மனின் மீது அளவற்ற பக்தி கொண்ட மகத்தான சக்தி உபாசகராக விளங்கினார். அம்மனிடமிருந்து ஒரு கணமும் பிரியாத ஆழ்ந்த பக்தி நிலையில் வாழ்ந்தார். இவர் புகழ்பெற்ற ஞானி, அறிஞர், சாக்தேய உபாசகர் மற்றும் தாந்திரீக வழிபாட்டு முறைகளில் தேர்ச்சி பெற்றவர். இவரது வாழ்க்கையும் அற்புதங்களும், கேரளத்தின் பாரம்பரிய நாட்டுப்புறக் கதைகளைத் தொகுத்து வழங்கும் கொட்டாரத்தில் சங்குண்ணியின் புகழ்பெற்ற ஐதீஹ்யமாலா என்ற நூலில் விரிவாகப் பதிவு செய்யப்பட்டுள்ளன.",

            temple:
                "இந்தத் திருக்கோயில் கேரள மாநிலம், எர்ணாகுளம் மாவட்டம், வடக்கு பரவூரில் அமைந்துள்ள பழமையும் சிறப்பும் மிக்க புனிதத் தலமாகும். நான்கு சாலைகள் சந்திக்கும் சந்திப்பின் மையப்பகுதியில் இக்கோயில் தனித்துவமாக அமைந்துள்ளது. நாள் முழுவதும் நான்கு திசைகளிலிருந்தும் வாகனங்கள் இக்கோயிலைச் சுற்றிச் செல்கின்றன.\n\nபிரம்மாண்டமான ஆலமரத்தின் நிழலில் அமைந்துள்ள இப்புனிதத் தலத்தில், பத்ரகாளி அம்மனின் பிரதிஷ்டையும் ஆலமரத்தின் வேர்களும் இயற்கையான மண்ணிலேயே அமைந்துள்ளன. அவற்றிற்கு உயர்த்தப்பட்ட மேடையோ பீடமோ இல்லை. இப்புனிதத் தலம் நான்கு அடி உயரமுள்ள எளிய வட்ட வடிவிலான சுற்றமைப்பால் சூழப்பட்டுள்ளது.\n\nவெளித்தோற்றத்தில் எளிமையாகவும், பரபரப்பான போக்குவரத்துக்கு மத்தியிலும் அமைந்திருந்தாலும், இக்கோயில் அசாதாரணமான தெய்வீக அருளாற்றலையும் சைதன்யத்தையும் வெளிப்படுத்துகிறது. புளியம்பிள்ளி நம்பூதிரியின் ஆன்மிகச் சக்தி இந்த ஆலமரத்தில் உறைந்திருப்பதாக நம்பப்படுகிறது. தலைமுறை தலைமுறையாகப் பக்தர்கள் அசைக்க முடியாத நம்பிக்கையுடன் இப்புனிதத் தலத்திற்கு வந்து வழிபட்டு வருகின்றனர். பத்ரகாளி அம்மன் தங்களது பிரார்த்தனைகளுக்குச் செவிசாய்த்து, பாதுகாப்பு, மனவலிமை மற்றும் அருளை வழங்குவதாக அவர்கள் நம்புகின்றனர்.",

            upasanaTitle: "தீவிர உபாசனை (பக்தி வழிபாடு)",

            upasana:
                "புளியம்பிள்ளி நம்பூதிரி பத்ரகாளி அம்மனின் தீவிர பக்தராக விளங்கினார். ஆதிபராசக்தியின் உக்கிர வடிவமான பத்ரகாளி அம்மனை வழிபட்டு அருளைப் பெறுவதற்காகக் கடுமையான தவத்தையும் ஆன்மிகப் பயிற்சிகளையும் மேற்கொண்டார்.\n\nபுளியம்பிள்ளி நம்பூதிரி தமது மந்திர சக்தியால் தீய சக்திகளை விரட்டும் ஆற்றல் பெற்றிருந்தார் என்றும், பத்ரகாளி அம்மனின் மீது அவர் கொண்டிருந்த வழிபாடு மிகவும் தீவிரமானதும் வலிமைமிக்கதுமாக இருந்தது என்றும் கூறப்படுகிறது. அவருடைய ஆன்மிக ஆற்றலின் முன்னால் எந்தத் தீய சக்திகளும் நிலைத்து நிற்க முடியாது என்ற அளவுக்கு அவருடைய உபாசனை சிறப்புமிக்கதாக இருந்ததாகப் பாரம்பரியக் கதைகள் எடுத்துரைக்கின்றன.",

            miracleTitle: "இரண்டு நிலவுகளின் அதிசயம்",

            miracle:
                "புளியம்பிள்ளி நம்பூதிரியின் பெயருடன் தொடர்புடைய மிகவும் புகழ்பெற்ற நாட்டுப்புறக் கதை ஒன்று, அவருடைய ஆன்மிக ஆற்றலைச் சந்தேகித்த உள்ளூர் மன்னர் ஒருவரைப் பற்றிக் கூறுகிறது.\n\nஇருள் சூழ்ந்த ஆடிக் கால அமாவாசை இரவில், தனது அபாரமான ஆன்மிக வலிமையாலும் பத்ரகாளி அம்மனின் அருளாலும், நள்ளிரவு வானில் ஒரே நேரத்தில் இரண்டு ஒளிவீசும் முழுநிலவுகள் தோன்றச் செய்ததாகக் கூறப்படுகிறது.\n\nஇந்த அதிசயக் காட்சியைக் கண்ட மன்னரும் அங்கிருந்த மக்களும் வியப்பிலும் பிரமிப்பிலும் ஆழ்ந்தனர். இந்த நிகழ்வு புளியம்பிள்ளி நம்பூதிரியின் ஆன்மிக வலிமையையும் பத்ரகாளி அம்மனின் அருளையும் எடுத்துரைக்கும் புகழ்பெற்ற பாரம்பரியக் கதையாக விளங்குகிறது.",
        },
    };

    // Malayalam uses English as its source for Google Translate.
    const text = language === "ta" ? content.ta : content.en;

    // Block Google Translate only when showing your manual Tamil text.
    const translationProps =
        language === "ta"
            ? { className: "notranslate", translate: "no" }
            : {};

    return (
        <div className="frontpage">
            <div className="history-section">
                <h2 {...translationProps}>{text.title}</h2>

                <p
                    {...translationProps}
                    style={{ whiteSpace: "pre-line" }}
                >
                    {text.history}
                </p>

                <p
                    {...translationProps}
                    style={{ whiteSpace: "pre-line" }}
                >
                    {text.temple}
                </p>

                <h3 {...translationProps}>{text.upasanaTitle}</h3>

                <p
                    {...translationProps}
                    style={{ whiteSpace: "pre-line" }}
                >
                    {text.upasana}
                </p>

                <h3 {...translationProps}>{text.miracleTitle}</h3>

                <p
                    {...translationProps}
                    style={{ whiteSpace: "pre-line" }}
                >
                    {text.miracle}
                </p>
            </div>

            <div className="image-section">
                <img
                    src={templeImage}
                    alt="Goddess Bhadrakali"
                    className="front-image"
                />
            </div>
        </div>
    );
}

export default Frontpage;
